<!-- <div class="icon">
	<img [src]="iconImage" [attr.alt]="title ? title.toLowerCase() : ''" />
</div>
<div class="container">
	<div *ngIf="promoName" class="title" [innerHtml]="promoName"></div>
	<div
		*ngIf="promoDescription"
		class="subtitle"
		[innerHtml]="promoDescription"
	></div>
</div> -->

<div class="icon">
	<img [src]="iconImage" [attr.alt]="promoName ? promoName.toLowerCase() : ''" />
</div>
<div class="details">
	<div *ngIf="promoName" class="title" [innerHtml]="promoName"></div>
	<div
		*ngIf="marketing"
		class="marketing-text"
		[ngClass]="marketing.textDecoration"
		[innerHtml]="marketing.text"
	></div>
	<div class="descriptions" *ngIf="promoDescription">
		<span class="price-text">{{ promoDescription }}</span>
	</div>
</div>
<div class="toggle-icon">
</div>

